(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gypb-free-shipping-widget"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var widget = document.getElementById('gypb-shipping-widget');
    if (!widget) return;

    // Load strings from JSON tag (Liquid is not processed inside {% javascript %} blocks)
    var STRINGS = {
      tagPerfect: "Add this to unlock free shipping!",
      msgTemplate: "You're <strong>{amount}</strong> away from <strong>free shipping</strong>.",
      msgSuccess: "Your order qualifies for <strong>FREE shipping</strong>. Cheers!"
    };
    try {
      var stringsEl = document.querySelector('[data-gypb-strings]');
      if (stringsEl) STRINGS = Object.assign(STRINGS, JSON.parse(stringsEl.textContent));
    } catch (e) {}

    var THRESHOLD     = parseInt(widget.dataset.threshold, 10) || 0;
    var AUTO_OPEN     = widget.dataset.autoOpen === 'true';
    var SUGGEST_AT    = (parseInt(widget.dataset.suggestAt, 10) || 30) / 100;
    var MODE          = widget.dataset.mode;
    var MIN_BOOSTER   = (parseFloat(widget.dataset.minPrice) || 0) * 100;
    var MAX_BOOSTER   = (parseFloat(widget.dataset.maxPrice) || 99999) * 100;
    var EXCLUDE_TAGS  = (widget.dataset.excludeTags || '').toLowerCase().split(/,\s*/).filter(Boolean);
    var POPUP_DELAY   = parseInt(widget.dataset.popupDelay, 10);
    if (isNaN(POPUP_DELAY)) POPUP_DELAY = 1500;

    var TAG_DEFAULT = widget.querySelector('[data-gypb-suggestion-tag]').textContent.trim();
    var TAG_PERFECT = STRINGS.tagPerfect;
    var MSG_TEMPLATE = STRINGS.msgTemplate;
    var MSG_SUCCESS = STRINGS.msgSuccess;

    var fillEl       = widget.querySelector('[data-gypb-fill]');
    var currentEl    = widget.querySelector('[data-gypb-current]');
    var messageEl    = widget.querySelector('[data-gypb-message]');
    var titleProg    = widget.querySelector('[data-state="progress"]');
    var titleSuccess = widget.querySelector('[data-state="success"]');
    var suggestion   = widget.querySelector('[data-gypb-suggestion]');
    var suggImage    = widget.querySelector('[data-gypb-suggestion-image]');
    var suggTitle    = widget.querySelector('[data-gypb-suggestion-title]');
    var suggPrice    = widget.querySelector('[data-gypb-suggestion-price]');
    var suggTag      = widget.querySelector('[data-gypb-suggestion-tag]');
    var addBtn       = widget.querySelector('[data-gypb-add]');
    var closeBtns    = widget.querySelectorAll('[data-gypb-close]');

    var CACHE_KEY = 'gypb-products-v1';
    var CACHE_TIME_KEY = 'gypb-products-time';
    var CACHE_TTL = 5 * 60 * 1000;
    var MAX_PAGES = 4;
    var PAGE_SIZE = 250;

    function readCache() {
      try {
        var t = parseInt(sessionStorage.getItem(CACHE_TIME_KEY) || '0', 10);
        if (Date.now() - t < CACHE_TTL) {
          var raw = sessionStorage.getItem(CACHE_KEY);
          if (raw) return JSON.parse(raw);
        }
      } catch (e) {}
      return null;
    }
    function writeCache(data) {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
        sessionStorage.setItem(CACHE_TIME_KEY, Date.now().toString());
      } catch (e) {}
    }
    function normalize(p) {
      var availableVariant = null;
      var variants = p.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { availableVariant = variants[i]; break; }
      }
      if (!availableVariant) return null;
      var imgSrc = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
      if (imgSrc && imgSrc.indexOf('?') === -1) {
        imgSrc = imgSrc.replace(/(\.(?:jpg|jpeg|png|gif|webp))(?=\?|$)/i, '_200x$1');
      }
      return {
        id: availableVariant.id,
        title: p.title,
        handle: p.handle,
        tags: (p.tags || '').toString().toLowerCase().split(/,\s*/).filter(Boolean),
        price: Math.round(parseFloat(availableVariant.price) * 100),
        image: imgSrc,
        available: true
      };
    }
    function fetchPage(page, acc) {
      acc = acc || [];
      return fetch('/products.json?limit=' + PAGE_SIZE + '&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (!products.length) return acc;
          acc = acc.concat(products);
          if (products.length < PAGE_SIZE || page >= MAX_PAGES) return acc;
          return fetchPage(page + 1, acc);
        })
        .catch(function () { return acc; });
    }
    function fetchAllProducts() {
      var cached = readCache();
      if (cached) return Promise.resolve(cached);
      return fetchPage(1).then(function (products) {
        var normalized = products.map(normalize).filter(Boolean);
        writeCache(normalized);
        return normalized;
      });
    }

    var productsPromise = null;
    var loadedProducts = [];

    if (MODE === 'auto') {
      productsPromise = fetchAllProducts();
      productsPromise.then(function (p) { loadedProducts = p || []; });
    } else if (MODE === 'single_product') {
      var singleScript = document.querySelector('[data-gypb-single-product]');
      if (singleScript) {
        try { loadedProducts = [JSON.parse(singleScript.textContent)]; } catch (e) {}
      }
    }

    function pickBooster(gapCents, cartItemIds) {
      cartItemIds = cartItemIds || [];
      if (!loadedProducts.length) return null;
      var eligible = loadedProducts.filter(function (p) {
        if (!p.available) return false;
        if (cartItemIds.indexOf(p.id) > -1) return false;
        if (MODE === 'auto') {
          if (p.price < MIN_BOOSTER || p.price > MAX_BOOSTER) return false;
          if (EXCLUDE_TAGS.length && p.tags && p.tags.some(function (t) { return EXCLUDE_TAGS.indexOf(t) > -1; })) return false;
        }
        return true;
      });
      if (!eligible.length) return null;
      var closesGap = eligible.filter(function (p) { return p.price >= gapCents; }).sort(function (a, b) { return a.price - b.price; });
      if (closesGap.length) return { item: closesGap[0], perfect: true };
      var biggest = eligible.slice().sort(function (a, b) { return b.price - a.price; });
      return { item: biggest[0], perfect: false };
    }

    function formatMoney(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function getCart() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }
    function renderSuggestion(pick) {
      if (!pick || !pick.item) { suggestion.hidden = true; return; }
      var item = pick.item;
      suggestion.hidden = false;
      suggImage.src = item.image || '';
      suggImage.alt = item.title;
      suggTitle.textContent = item.title;
      suggPrice.textContent = formatMoney(item.price);
      addBtn.dataset.variantId = item.id;
      if (pick.perfect) {
        suggestion.classList.add('is-perfect-match');
        suggTag.textContent = TAG_PERFECT;
      } else {
        suggestion.classList.remove('is-perfect-match');
        suggTag.textContent = TAG_DEFAULT;
      }
    }
    function render(cart) {
      var total = cart.total_price;
      var remaining = Math.max(0, THRESHOLD - total);
      var percent = THRESHOLD > 0 ? Math.min(100, (total / THRESHOLD) * 100) : 0;
      fillEl.style.width = percent + '%';
      currentEl.textContent = formatMoney(total);
      if (remaining === 0 && total > 0) {
        widget.classList.add('is-success');
        titleProg.hidden = true;
        titleSuccess.hidden = false;
        messageEl.innerHTML = MSG_SUCCESS;
        suggestion.hidden = true;
        return;
      }
      widget.classList.remove('is-success');
      titleProg.hidden = false;
      titleSuccess.hidden = true;
      messageEl.innerHTML = MSG_TEMPLATE.replace('{amount}', formatMoney(remaining));
      if (MODE === 'off' || total < THRESHOLD * SUGGEST_AT) { suggestion.hidden = true; return; }
      if (MODE === 'auto' && !loadedProducts.length && productsPromise) {
        suggestion.hidden = true;
        productsPromise.then(function () {
          if (widget.classList.contains('is-open')) { getCart().then(render).catch(function () {}); }
        });
        return;
      }
      var cartIds = (cart.items || []).map(function (i) { return i.id; });
      var pick = pickBooster(remaining, cartIds);
      renderSuggestion(pick);
    }

    function open() {
      widget.classList.add('is-open');
      widget.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      getCart().then(render).catch(function () {});
    }
    function close() {
      widget.classList.remove('is-open');
      widget.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && widget.classList.contains('is-open')) close();
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = this.dataset.variantId;
        if (!variantId) return;
        var btn = this;
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function () { return getCart(); })
          .then(function (cart) {
            render(cart);
            btn.disabled = false;
            btn.textContent = originalText;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Try again';
          });
      });
    }

    if (AUTO_OPEN) {
      var triggerLock = false;
      var trigger = function () {
        if (triggerLock) { getCart().then(render).catch(function () {}); return; }
        triggerLock = true;
        setTimeout(function () { open(); triggerLock = false; }, POPUP_DELAY);
      };

      // Method 1: fetch interception
      var originalFetch = window.fetch;
      window.fetch = function () {
        var url = (arguments[0] || '').toString();
        var init = arguments[1] || {};
        var method = (init.method || '').toUpperCase();
        var isCartAdd = /\/cart\/add(\.js)?($|\?)/.test(url) && method === 'POST';
        return originalFetch.apply(this, arguments).then(function (res) {
          if (isCartAdd && res.ok) trigger();
          return res;
        });
      };

      // Method 2: XHR interception
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) { this._gypbUrl = u; this._gypbMethod = m; return origOpen.apply(this, arguments); };
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        var self = this;
        if (this._gypbUrl && /\/cart\/add(\.js)?($|\?)/.test(this._gypbUrl) && (this._gypbMethod || '').toUpperCase() === 'POST') {
          this.addEventListener('load', function () { if (self.status >= 200 && self.status < 300) trigger(); });
        }
        return origSend.apply(this, arguments);
      };

      // Method 3: theme cart events
      var themeEvents = [
        'cart:added', 'cart:item-added', 'cart:refresh', 'cart:updated',
        'cart:item:added', 'cart:items:added', 'product:added',
        'ajaxProduct:added', 'on:cart:add', 'shopify:cart:add',
        'theme:cart:add', 'cart:open', 'cart:drawer:open',
        'ajaxCart.afterCartLoad'
      ];
      themeEvents.forEach(function (eventName) {
        document.addEventListener(eventName, trigger);
        window.addEventListener(eventName, trigger);
      });

      // Method 4: cart polling (bulletproof fallback)
      var lastItemCount = -1;
      function pollCart() {
        if (widget.classList.contains('is-open')) return;
        getCart().then(function (cart) {
          if (lastItemCount === -1) { lastItemCount = cart.item_count; return; }
          if (cart.item_count > lastItemCount) { lastItemCount = cart.item_count; trigger(); }
          else { lastItemCount = cart.item_count; }
        }).catch(function () {});
      }
      setInterval(pollCart, 1500);
    }

    window.GYPBShippingWidget = {
      open: open,
      close: close,
      refresh: function () { return getCart().then(render); },
      reloadProducts: function () {
        try { sessionStorage.removeItem(CACHE_KEY); sessionStorage.removeItem(CACHE_TIME_KEY); } catch (e) {}
        if (MODE === 'auto') {
          productsPromise = fetchAllProducts();
          return productsPromise.then(function (p) { loadedProducts = p || []; });
        }
        return Promise.resolve();
      }
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
